"use client";

import React, { useContext } from "react";
import LanguageSelector from "../../molecules/LanguageSelector";
import classNames from "classnames";
import Link from "next/link";
import Wrapper from "../Wrapper";
import Image from "next/image";
import { GlobalContext } from "@/contexts/SiteDataContext";
import "react-loading-skeleton/dist/skeleton.css";
import "./styles.scss";

interface HeaderProps {
  headerTitle?: string;
  /** Same background, shadow, and compact logo as a titled form header, without rendering a title. */
  formHeaderStyle?: boolean;
  plainHeader?: boolean;
  headerLanding?: boolean;
  bigMaxWidth?: boolean;
  hideLanguageSelector?: boolean;
  lang: string;
}

const Header = ({
  headerTitle,
  formHeaderStyle = false,
  plainHeader,
  headerLanding,
  bigMaxWidth,
  hideLanguageSelector,
  lang,
}: HeaderProps) => {
  const {
    siteData: { theme, metadata },
  } = useContext(GlobalContext).context;
  const logo_filename = metadata?.logo_filename || "logo.svg";
  const logo_redirect = metadata?.logo_redirect || "/home";

  const classnames = classNames("header", {
    "header--hasTitle": (Boolean(headerTitle) || formHeaderStyle) && !plainHeader,
    "header--plain": plainHeader,
    "header--headerLanding": headerLanding,
    "header--big-max-width": bigMaxWidth,
  });

  return (
    <header className={classnames}>
      <Wrapper>
        <div className="header__container">
          <div className="header__group">
            <Link
              className=""
              href={logo_redirect}>
              <Image
                priority
                fetchPriority="high"
                width={50}
                height={50}
                alt="header logo"
                className="header__logo"
                data-testid="logo"
                src={`/assets/logos/${theme}/site/${logo_filename}`}
              />
            </Link>
            {headerTitle ? (
              <h1 className="header__title">{headerTitle}</h1>
            ) : (
              formHeaderStyle && (
                <span
                  className="header__title react-loading-skeleton"
                  style={{ display: "block", height: 36, width: "70%", maxWidth: 280 }}
                  data-testid="header-title-skeleton"
                  aria-hidden="true"
                />
              )
            )}
            <LanguageSelector
              hideLanguageSelector={hideLanguageSelector}
              language={lang}
            />
          </div>
        </div>
      </Wrapper>
    </header>
  );
};

export default Header;
